import { Button } from "@/components/ui/button";
import UpcomingPrize from "../components/upcoming-prize";
import { FILTERS, useUpcomingPrizes } from "../hooks/use-upcoming-prizes";

const STYLES = {
	background:
		"radial-gradient(58.09% 54.69% at 29.83% 2.93%, rgba(46, 219, 202, 0.30) 0%, rgba(8, 50, 46, 0.00) 100%), radial-gradient(301.04% 189.4% at 89.12% -41.16%, #2EDBCA 4.81%, #004096 43.8%, #470096 100%)",
	backgroundBlendMode: "plus-lighter, normal",
};

function UpComingPrizes() {
	const {
		isMobile,
		selectedFilter,
		setSelectedFilter,
		visibleCount,
		visiblePrizes,
		filteredPrizes,
		handleLoadMore,
		upcomingPrizes,
	} = useUpcomingPrizes();

	if (!upcomingPrizes.length) return null;

	return (
		<div
			style={STYLES}
			className="relative flex flex-col gap-12 px-4 py-16 text-center md:px-37 md:py-50 md:pt-70"
		>
			<div className="flex flex-col gap-8">
				<span className="web-heading-h2 text-white">
					Upcoming <span className="text-green-300">Prizes</span>
				</span>
				<img
					src="icons/trophy.png"
					alt="Trophy"
					className="absolute top-2 right-3 h-15 w-15 md:top-50 md:right-30 md:h-50 md:w-50"
				/>
				<div className="flex w-full justify-center">
					<div className="flex w-fit flex-row rounded-[32px] bg-white p-2">
						{FILTERS.map((filter) => (
							<p
								key={filter.value}
								onClick={() => setSelectedFilter(filter.value)}
								className={
									selectedFilter === filter.value
										? "cursor-default rounded-[32px] bg-blue-700 px-4 py-2 text-white"
										: "cursor-pointer px-4 py-2"
								}
							>
								{filter.label}
							</p>
						))}
					</div>
				</div>
			</div>

			<div className="w-full gap-8 overflow-x-auto max-sm:flex max-sm:flex-col">
				<div className="flex-row gap-4 max-sm:grid max-sm:grid-cols-2 max-sm:flex-wrap md:flex md:min-h-137 md:gap-8">
					{visiblePrizes.map((prize, idx) => (
						<UpcomingPrize giveaway={prize} key={prize.id ?? idx} />
					))}
				</div>
				{isMobile && visibleCount < filteredPrizes.length && (
					<div className="flex w-full flex-row justify-center">
						<Button
							onClick={handleLoadMore}
							variant="secondary"
							className="bg-white-10 border-white-20 w-50 text-white"
						>
							Load More
						</Button>
					</div>
				)}
			</div>
		</div>
	);
}

export default UpComingPrizes;
